'use strict';

angular.module('mobile-apps').factory('MobileAppIntegrations', ['$resource',
    function($resource) {
        return $resource(
            'v1/projects/:mobileAppId/integrations',
			{
				mobileAppId: '@mobileAppId'
			},
            {
				remove:
					{
						method: 'DELETE',
						cache: false
					}
            }
        );
    }
]);
